// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"42":"loan-value","77":"banking","437":"cover","887":"person-data","981":"documents"}[chunkId] + "." + {"42":"00cff972","77":"54480058","437":"737087ac","887":"0f611e97","981":"6ee65ee4"}[chunkId] + ".css";
};